import { Component } from "@angular/core";
import { AlertController } from "ionic-angular";
import { Member } from '../../models/interfaces/member.model';
import { Tracking } from '../../models/interfaces/tracking.model';
import { LatLng } from '../../models/interfaces/tracking.model';
import { ModalController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { PrivilegeRole } from "../../models/interfaces/privilegerole.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

@Component({
  selector: "page-tracking",
  templateUrl: "tracking.html",
})

export class TrackingPage {
  private page: string = "tracking";
  coordinates;
  latitude: number = 1.3031071238648482;
  longitude: number = 103.76710776497747;

  lat: number = 1.3031071238648482;
  lng: number = 103.76710776497747;
  hashname: string = "ThisSIs asdf ";
  //ltd_lng: number = this.latitude + this.longitude;
  zoom: number = 16;
  currentUser: Observable<Member>;
  member: Member;
  tmp_mb_id: number = 1;
  currMbr: String = 'NotDefined';
  String = 'Peter';
  private keys_tracking: string[];
  private tracking$: any;
  private endmarkers = [];
  private trackinglines = [];
  private filteredLines = [];
  private xxarkers: Tracking[] = [];
  private Hashxxarkers: LatLng[] = [];
  private latlng = [];

  
  private tracking_route = [];

  constructor(public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController,
    private db: DbserviceProvider, public modalCtrl: ModalController, ) {

    console.log("TrackingPage constructor");
    if (this.authService.currentUser) {
      this.authService.currentUser.subscribe(
        user => {
          this.currentUser = user;
        });
    }
    this.db.dbCol({
      "action": "dml", "mapObject": "dml",
      "query": "DELETE FROM tracking WHERE mb_id=" + this.tmp_mb_id,
    })
      .subscribe((ret) => {
        this.getPosition().subscribe(
          (pos: Position) => {
            //this.latitude = pos.coords.latitude
            //this.longitude = pos.coords.longitude
            this.db.dbCol({ "action": "insert", "mapObject": "tracking", "hl_id": this.navParams.get("hareline").hl_id, "mb_id": this.tmp_mb_id, "tr_lng": pos.coords.longitude, "tr_lat": pos.coords.latitude })
              .subscribe((ret3) => {
              });
          });
      });
  }

 getRandomColor2() {
  var length = 6;
  var chars = '0123456789ABCDEF';
  var hex = '#';
  while(length--) hex += chars[(Math.random() * 16) | 0];
  return hex;
}

  private onInitPage() {
    console.log("TrackingPage onInitPage");
    this.tracking$ = this.db.dbCol({
      "action": "select", "mapObject": "vw_tracking",
      "sqlExtended": " where hl_id= " + this.navParams.get("hareline").hl_id + " order by hl_id, mb_id, created_at",
    })
      .subscribe((tr) => {
        // Filter for unique hashnames
        const uniquehashnames = tr.map(item => item.mb_hashname)
          .filter((value, index, self) => self.indexOf(value) === index)

        this.xxarkers = [];
        for (let i = 0; i < uniquehashnames.length; i++) {
          //this.xxarkers[i] = [];
          
          this.xxarkers[i].mb_hashname = uniquehashnames[i];
          this.xxarkers[i].strokeColor=this.getRandomColor2();

          const hashnametracking = tr.filter(xx => xx.mb_hashname === uniquehashnames[i])
          this.Hashxxarkers = [];
          this.endmarkers[i] = [];
          for (let j = 0; j < hashnametracking.length; j++) {
            this.xxarkers[i].hl_id = Number(hashnametracking[j].hl_id);
            this.xxarkers[i].mb_id = Number(hashnametracking[j].mb_id);
            this.xxarkers[i].draggable = false;
            //this.Hashxxarkers[j] = [];
            this.Hashxxarkers[j].tr_id = Number(hashnametracking[j].tr_id);
            this.Hashxxarkers[j].tr_lat = Number(hashnametracking[j].tr_lat);
            this.Hashxxarkers[j].tr_lng = Number(hashnametracking[j].tr_lng);
            if (j === hashnametracking.length - 1 ) {
              this.endmarkers[i] = [];
              this.endmarkers[i].tr_lat = Number(hashnametracking[j].tr_lat);
              this.endmarkers[i].tr_lng = Number(hashnametracking[j].tr_lng);
              this.endmarkers[i].mb_hashname = this.xxarkers[i].mb_hashname;
            }
          }
          //this.xxarkers[i].latlng = [];
          //this.xxarkers[i].latlng = this.Hashxxarkers;
        }
      });
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }

  public getPosition(): Observable<Position> {
    console.log("TrackingPage getPosition");
    return Observable.create(
      (observer) => {
        navigator.geolocation.watchPosition((pos: Position) => {
          observer.next(pos);
          //this.longitude = pos.coords.longitude
          //this.latitude = pos.coords.latitude

          this.db.dbCol({ "action": "insert", "mapObject": "tracking", "hl_id": this.navParams.get("hareline").hl_id, "mb_id": this.tmp_mb_id, "tr_lng": pos.coords.longitude, "tr_lat": pos.coords.latitude })
            .subscribe((ret3) => {
              this.db.dbCol({
                "action": "select", "mapObject": "vw_tracking", "sqlExtended": " where hl_id = " + this.navParams.get("hareline").hl_id + "  order by hl_id, mb_id, created_at"
              })
              .subscribe((tr) => {
                // Filter for unique hashnames
                const uniquehashnames = tr.map(item => item.mb_hashname)
                  .filter((value, index, self) => self.indexOf(value) === index)
                this.xxarkers = [];
                for (let i = 0; i < uniquehashnames.length; i++) {
                  //this.xxarkers[i] = [];
                  
        
                  this.xxarkers[i].mb_hashname = uniquehashnames[i];
                  this.xxarkers[i].strokeColor=this.getRandomColor2();
        
                  const hashnametracking = tr.filter(xx => xx.mb_hashname === uniquehashnames[i])
                  this.Hashxxarkers = [];
                  this.endmarkers[i] = [];
                  for (let j = 0; j < hashnametracking.length; j++) {
                    this.xxarkers[i].hl_id = Number(hashnametracking[j].hl_id);
                    this.xxarkers[i].mb_id = Number(hashnametracking[j].mb_id);
                    this.xxarkers[i].draggable = false;
                    //this.Hashxxarkers[j] = [];
                    this.Hashxxarkers[j].tr_id = Number(hashnametracking[j].tr_id);
                    this.Hashxxarkers[j].tr_lat = Number(hashnametracking[j].tr_lat);
                    this.Hashxxarkers[j].tr_lng = Number(hashnametracking[j].tr_lng);
                    if (j === hashnametracking.length - 1 ) {
                      this.endmarkers[i] = [];
                      this.endmarkers[i].tr_lat = Number(hashnametracking[j].tr_lat);
                      this.endmarkers[i].tr_lng = Number(hashnametracking[j].tr_lng);
                      this.endmarkers[i].mb_hashname = this.xxarkers[i].mb_hashname;
                    }
                  }
                  //this.xxarkers[i].latlng = [];
                  //this.xxarkers[i].latlng = this.Hashxxarkers;
                  
                }
              });
            });
          /*
                    this.db.dbCol({ "action": "insert", "mapObject": "tracking", "hl_id": this.navParams.get("hareline").hl_id, "mb_id": 2, "tr_lng": this.longitude, "tr_lat": this.latitude })
            */
        }),
          // tslint:disable-next-line: no-unused-expression
          () => {
            console.log('Position is not available');
          },
          // tslint:disable-next-line: no-unused-expression
          {
            enableHighAccuracy: true
          };
      });
  }

  private ionViewWillEnter() {
    console.log("TrackingPage ionViewWillEnter");
    this.onInitPage();
  }

  private ngOnDestroy() {
    console.log("TrackingPage ngOnDestroy");
  }

}



// WEBPACK FOOTER //
// ./src/pages/tracking/tracking.ts